import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view/dist/viewport';

import { MasterPage } from './master-page';

const MasterPageSideRailTypes = MasterPage.wrappedComponent.sideRailTypes;
const MasterPageToolbarTypes = MasterPage.wrappedComponent.toolbarTypes;

export const MasterPageWrapper = ({ children, ...masterProps }) => (
  <Viewport>
    <ViewSmall>
      <MasterPage
        {...masterProps}
        pageHeaderClassName="header--with-overlay-toolbar"
        toolbarType={MasterPageToolbarTypes.TRANSPARENT_OVERLAY}
      >
        {children}
      </MasterPage>
    </ViewSmall>
    <ViewLarge>
      <AbacusExperiment name="Small_Crafts_BringMesoAdsToDatelessPdp">
        <AbacusControl>
          <MasterPage
            {...masterProps}
            toolbarType={MasterPageToolbarTypes.NORMAL}
            sideRailType={
              masterProps.searchCriteria && masterProps.searchCriteria.isDateless ? '' : MasterPageSideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR
            }
          >
            {children}
          </MasterPage>
        </AbacusControl>
        <AbacusVariant bucket={1}>
          <MasterPage
            {...masterProps}
            toolbarType={MasterPageToolbarTypes.NORMAL}
            sideRailType={MasterPageSideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR}
          >
            {children}
          </MasterPage>
        </AbacusVariant>
      </AbacusExperiment>
    </ViewLarge>
  </Viewport>
);
